import { FormFieldType } from '../../../enums';
import { DeliveryCompanyOrderFormData, FormFieldData } from '../../../interfaces';

export const deliveryCompanyOrderFormStructure: FormFieldData<keyof DeliveryCompanyOrderFormData>[] = [
  {
    label: 'onarte.ui.deliveryCompanyOrderForm.firstName.label',
    type: FormFieldType.Input,
    name: 'firstName'
  },
  {
    label: 'onarte.ui.deliveryCompanyOrderForm.lastName.label',
    type: FormFieldType.Input,
    name: 'lastName'
  },
  {
    label: 'onarte.ui.deliveryCompanyOrderForm.phone.label',
    type: FormFieldType.Input,
    name: 'phone',
    additionalFieldProps: {
      withOnlyNumbersAllowed: true
    }
  },
  {
    label: 'onarte.ui.deliveryCompanyOrderForm.email.label',
    type: FormFieldType.Input,
    name: 'email'
  },
  {
    label: 'onarte.ui.deliveryCompanyOrderForm.street.label',
    type: FormFieldType.Input,
    name: 'street',
  },
  {
    label: 'onarte.ui.deliveryCompanyOrderForm.houseNumber.label',
    type: FormFieldType.Input,
    name: 'houseNumber'
  },
  {
    label: 'onarte.ui.deliveryCompanyOrderForm.apartmentNumber.label',
    type: FormFieldType.Input,
    name: 'apartmentNumber'
  },
  {
    label: 'onarte.ui.deliveryCompanyOrderForm.postalCode.label',
    type: FormFieldType.Input,
    name: 'postalCode',
    additionalFieldProps: {
      format: '##-###'
    }
  },
  {
    label: 'onarte.ui.deliveryCompanyOrderForm.city.label',
    type: FormFieldType.Input,
    name: 'city'
  },
  {
    label: 'onarte.ui.deliveryCompanyOrderForm.country.label',
    type: FormFieldType.Input,
    name: 'country',
    disabled: true,
  }
];
